<template>
  <platLogin :login-type="0"></platLogin>
</template>

<script>
export default {
  components: {
    platLogin: () => import('./platLogin.vue')
  }
}
</script>